import React from "react";
import HideableErrorMessage from "components/shared/alerts/HideableErrorMessage";
import { isNil } from "lodash";

export default (loading, error) => (
	<HideableErrorMessage
		show={!loading && !isNil(error)}
		text={"There was a problem loading the page. Please reload to try again."}
	/>
);
